// extracted by mini-css-extract-plugin
export default {"container":"InfoTable_container__ONby9","bookAppointment":"InfoTable_bookAppointment__d1eKd","hours":"InfoTable_hours__u1TMt","emergency":"InfoTable_emergency__1GQge"};